import { dinTestActions, widgetActions, wizardActions } from '@/store';
import { useNavigator } from 'hx-navigator';
import { useDispatch } from 'react-redux';
export function useEndSession() {
    var dispatch = useDispatch();
    var navigate = useNavigator().navigate;
    function handleEndSessionClick() {
        dispatch(dinTestActions.reset());
        dispatch(wizardActions.reset());
        dispatch(widgetActions.startNewSession());
        navigate('/');
    }
    return { handleEndSessionClick: handleEndSessionClick };
}
